import { render } from "./UiShareFacebook.vue?vue&type=template&id=49ce53cc&scoped=true"
import script from "./UiShareFacebook.vue?vue&type=script&lang=js"
export * from "./UiShareFacebook.vue?vue&type=script&lang=js"

import "./UiShareFacebook.vue?vue&type=style&index=0&id=49ce53cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49ce53cc"

export default script